// src\utils\yup.ts

import * as Yup from 'yup';

declare module 'yup' {
  interface MixedSchema {
    set(message: string): this;
  }
}

// Extend Yup with a custom Set validation method
Yup.addMethod(Yup.mixed, 'set', function (message) {
  return this.test('is-set', message, function (value) {
    const { path, createError } = this;
    return value instanceof Set || createError({ path, message: message ?? `${path} must be a Set` });
  }).test('not-empty', message, function (value) {
    const { path, createError } = this;
    return (value instanceof Set && value.size > 0) || createError({ path, message: message ?? `${path} must be a non-empty Set` });
  });
});

export default Yup;
